import type { ReactNode } from 'react'
import { Button } from '@systemeio/components'
import { useTranslation } from 'next-i18next'
import useStepRouter from '../hooks/use-step-router'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'

export const CourseStepButton = (): ReactNode => {
  const { t } = useTranslation()

  const { onNextStep, isEnd } = useStepRouter()

  return (
    <Button
      variant="secondary"
      className={`border-THEME-primary! bg-THEME-block-background! font-bold text-THEME-primary! hover:border-THEME-block-background! hover:bg-THEME-primary! hover:text-THEME-block-background! disabled:border-THEME-disabled! disabled:text-THEME-disabled! ${addPublicCustomClassNamePrefix(['course__button', 'course__button--secondary', isEnd ? 'course__button--mark-lecture-as-completed' : 'course__button--next-lecture'])}`}
      onClick={onNextStep}
      disabled={isEnd}
    >
      {isEnd ? t('course.course_completed') : t('course.next_step_button_label')}
    </Button>
  )
}
